module.exports = __webpack_public_path__ + "img/chevron-down.c859d2f0.svg";